import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { systemAPI } from '../../apis';
import { rewriteSettingRequestParams } from '../check';

const useGetIpasMapping = () => {
  const loginInfo = useSelector((state) => state.loginInfo);
  const [hospitalWardList, setHospitalWardList] = useState(null);
  const [InputValues, setInputValues] = useState({
    hospital: { value: '', index: -1 },
    ward: { value: '', index: -1 },
    ipasMapping: [
      {
        hospCode: '',
        wardCode: '',
      },
    ], // {} => hospCode , wardCode
    srsMapping: [
      {
        hospCode: '',
        wardCode: '',
      },
    ], // {} => hospCode , wardCode
    // IP Address or Computer Name
    alarm: [
      {
        alarmId: null,
        alarmType: 1,
        machineHostnameIp: '',
        status: 2 /** status: 1:open,2: close */,
        showLis: false,
        vol: 1,
      },
    ],
    // tvMapping: [
    //   {
    //     hospCode: '',
    //     wardCode: '',
    //   },
    // ],
    wardLocation: '',
  });

  const initInputValue = (hospitalWardData) => {
    let hospital = { value: '', index: -1 };
    let ward = { value: '', index: -1 };
    setInputValues({
      hospital,
      ward,
      wardLocation: '',
    });
    if (Array.isArray(hospitalWardData) && hospitalWardData.length > 0) {
      const firstHosp = hospitalWardData.find((item, index) => {
        if (item.hospitalId === loginInfo.hospitalId) {
          hospital = { value: loginInfo?.hospitalId, index: index };
          return true;
        }
        return false;
      });
      if (firstHosp?.wards?.length > 0) {
        firstHosp.wards.find((item, index) => {
          if (item.wardId === loginInfo.wardId) {
            ward = { value: item.wardId, index: index };
            return true;
          }
          return false;
        });
      }
    }
    setInputValues({
      hospital: hospital,
      ward: ward,
      ipasMapping: [], // {} => hospCode , wardCode
      srsMapping: [], // {} => hospCode , wardCode
      alarm: [],
      tvMapping: [],
      wardLocation: '',
    });
  };

  useEffect(() => {
    if (hospitalWardList) {
      const hospIndex = InputValues.hospital.index;
      const wardIndex = InputValues.ward.index;
      const { ipasMapping, srsMapping, wardId, alarm, tvMapping } =
        hospitalWardList?.[hospIndex]?.wards?.[wardIndex] ?? {};
      if (ipasMapping?.length === 0) {
        ipasMapping.push({
          hospCode: '',
          wardCode: '',
        });
      }
      if (srsMapping?.length === 0) {
        srsMapping.push({
          hospCode: '',
          wardCode: '',
        });
      }
      if (alarm?.length === 0) {
        alarm.push({
          alarmId: null,
          alarmType: 1,
          machineHostnameIp: '',
          status: 2,
          showLis: false,
          vol: 1,
        });
      }
      if (tvMapping?.length === 0) {
        tvMapping.push({
          hospCode: '',
          wardCode: '',
        });
      }
      setInputValues({
        ...InputValues,
        ipasMapping: ipasMapping || '',
        srsMapping: srsMapping || '',
        wardId,
        alarm: alarm || '',
        tvMapping: tvMapping || '',
        wardLocation: '',
      });
    }
  }, [InputValues.hospital.value, InputValues.ward.value, hospitalWardList]);

  const getSysDataMappingList = async () => {
    try {
      setHospitalWardList(null);
      const { result } =
        (await systemAPI.getSysDataMappingList(rewriteSettingRequestParams({ userId: loginInfo.userId }))) ?? {};
      setHospitalWardList(result);
      initInputValue(result);
    } catch (error) {
      console.log('error', error);
      setHospitalWardList(null);
    }
  };

  return [InputValues, getSysDataMappingList];
};

export default useGetIpasMapping;
